import React from "react";

const HeadingComp = (props) => {
  return <h2 className="edit-popup-heading ">{props.headingText}</h2>;
};

export default HeadingComp;
